module.exports = __webpack_public_path__ + "img/PNUD-Logo-Blue-Large.743fe33f.png";